export default __webpack_public_path__ + "static/media/CNo.21-3.b56e7475.jpg";